import React from "react";
import { Tabs as ReactTabs } from "react-tabs";

import { styled } from "@catchoftheday/theme";

import { BoxProps, boxStyleProps } from "../Box";

export const Tabs = styled(ReactTabs)`
  ${boxStyleProps}
`;

export type TabsProps = BoxProps & React.ComponentProps<typeof Tabs>;

export default Tabs;
